package com.anjuros.website.templates.template4.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.templates.template4.modules.Template4Project
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.EventListener

@Composable
fun Template4ObserverViewportEntered(
    sectionId:String,
    distanceFromTop:Double,
    onViewportEnteredLambda:()->Unit
){

    var viewportEntered by remember { mutableStateOf(false)}

    var listener = remember {
        EventListener {
            val top= document.getElementById(sectionId)?.getBoundingClientRect()?.top
            if(top!=null && top <distanceFromTop){
                viewportEntered=true
            }
        }
    }

    LaunchedEffect(viewportEntered){

        if(viewportEntered){
            onViewportEnteredLambda()
            window.removeEventListener(type="scroll", callback = listener)
        } else {
            window.addEventListener(type="scroll", callback = listener)
        }
    }

}

@Composable
fun Template4ObserverViewportEnteredForProject(
    sectionId:String,
    distanceFromTop:Double,
    template4Project: Template4Project,
    onViewportEnteredLambda:()->Unit
){

    var viewportEntered by remember { mutableStateOf(false)}

    var listener = remember {
        EventListener {
            val top= document.getElementById(sectionId)?.getBoundingClientRect()?.top
            if(top!=null && top <distanceFromTop){
                viewportEntered=true
            }
        }
    }
    
    LaunchedEffect(viewportEntered,template4Project){

        if(viewportEntered){
            onViewportEnteredLambda()
            window.removeEventListener(type="scroll", callback = listener)
        } else {
            window.addEventListener(type="scroll", callback = listener)
        }
    }

}


fun Template4Project.getNext(): Template4Project {
    var index = this.ordinal
    index++
    val mappedIndex = if(index== Template4Project.entries.size) 0 else index

    return Template4Project.entries[mappedIndex]
}


fun Template4Project.getPrevious(): Template4Project {
    var index = this.ordinal
    index--
    val mappedIndex = if(index==-1) Template4Project.entries.size-1 else index

    return Template4Project.entries[mappedIndex]
}
